import axios from 'axios'

export const httpClientPublic = axios.create({
  validateStatus(status) {
    return status >= 200 && status < 400
  },
})

export default httpClientPublic
